import ApisService from './index'
import { IUser , IUserUpdateRole} from '../interfaces/userInterfaces'
import { handleError } from '../utils/commonUtils'
import * as queryString from 'query-string'

export function createUser(data: IUser) {
  let bodyData: any = { ...data }
  const phoneNumber = data.phoneNumber || ""

  delete bodyData.phoneNumber
  if (phoneNumber.trim() != "") {
    bodyData.phone = { 
      phoneNumber: phoneNumber, 
      countryAccessCode: '84', }
  }
  if (!bodyData.birthDate) {
    delete bodyData.birthDate
  }
  return ApisService.post('/user/register', bodyData)
}

export async function login(username: string, password: string) {
  return await ApisService.post('/user/login', {
    username,
    password,
  })
}

export async function loginAll(username: string, password: string) {
  return await ApisService.post('/user/login-all-system', {
    username,
    password,
  })
}

export function updateProfile(data: IUser) {
  let bodyData: any = { ...data }
  const phoneNumber = data.phoneNumber || ""

  delete bodyData.phoneNumber
  if (phoneNumber.trim() != "") {
    bodyData.phone = { 
      phoneNumber: phoneNumber, 
      countryAccessCode: '84', }
  }
  if (!bodyData.birthDate) {
    delete bodyData.birthDate
  }
  return ApisService.put('/user/update-user-profile', bodyData)
}


export function updateUser(data: IUser) {
  let bodyData: any = { ...data }
  const phoneNumber = data.phoneNumber || ""

  delete bodyData.phoneNumber
  if (phoneNumber.trim() != "") {
    bodyData.phone = { 
      phoneNumber: phoneNumber, 
      countryAccessCode: '84', }
  }
  if (!bodyData.birthDate) {
    delete bodyData.birthDate
  }
  return ApisService.put('/user/update-user-profile/' + data.id, bodyData)
}


export function getUserInfo() {
  return ApisService.get('/user/get-user-info')
}

export function getDetailUser(id: string) {
  return ApisService.get('/user/get-user-info/' + id)
}

export function getListUser(querySt: any) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/user/get-user-list', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}



export function changePassword({
  oldPassword,
  newPassword,
  newPasswordRetype,
}: {
  oldPassword: string
  newPassword: string
  newPasswordRetype: string
}) {
  return ApisService.post('/user/change-password', {
    oldPassword,
    newPassword,
    newPasswordRetype,
  })
}


export function getListRole(query: any) {
  return ApisService.get('/user/get-roles', {
    params: query,
  })
}

export function getListProject() {
  return ApisService.get('/user/get-my-duan-list')
}

export function changeProject(projectId: number) {
  return ApisService.put('/user/' + projectId + '/doi-duan')
}


export function updateRole(data: IUserUpdateRole) {
  const bodyData = {...data, role: data.role != "" ? data.role : null}
  return ApisService.put('/user/' + data.projectId + '/update-role-duan', bodyData)
}


export function changeHeThong(heThongId: number) {
  return ApisService.put('/user/' + heThongId + '/doi-hethong')
}

export function getListHeThong() {
  return ApisService.get('/hethong/filter-hethong')
}

export function getListProjectBySystem(query: any) {
  return ApisService.get('/project/list', {
    params: query
  })
}

export function getListBranch(query: any) {
  return ApisService.get('/branch/list', {
    params: query
  })
}

export function getListRoleGroup() {
  return ApisService.get('/role-group/list')
}

export function updateUserRole(data: {
  userId: number,
  duAnId: number,
  chiNhanhId: number,
  nhomQuyenId: number
}) {
  return ApisService.post('/user/phanquyen', data)
}

export function deleteUserRole(data: {
  userId: number,
  duAnId: number,
  chiNhanhId: number,
  nhomQuyenId: number
}) {
  try {
    return ApisService.delete('/user/xoa-phanquyen', { data })
  } catch (err) {
    handleError(err)
    throw err
  }
}